/**
 * Formats a currency string for a controlled input, preserving mid-typing
 * state. Adds thousands separators to the integer portion only; the decimal
 * portion is passed through verbatim so trailing dots, trailing zeros, and
 * lone "." remain stable while the user is typing. Number.toLocaleString /
 * Intl.NumberFormat don't preserve those states and so aren't suitable here.
 */
export function formatPrizeDisplay(raw: string): string {
  if (raw === '' || raw === '.') {
    return raw
  }
  const [intPart, decPart] = raw.split('.')
  const intFormatted = intPart === '' ? '' : Number(intPart).toLocaleString('en-US')
  if (decPart !== undefined) {
    return `${intFormatted}.${decPart}`
  }
  return intFormatted
}

import { DateTime } from 'luxon'

export function formatIsoDateMMDDYYYY(iso: string | undefined): string | undefined {
  if (!iso) {
    return undefined
  }
  const dt = DateTime.fromISO(iso)
  if (!dt.isValid) {
    return iso
  }
  return dt.toFormat('MM/dd/yyyy')
}
